import { DefaultTheme } from './DefaultTheme';
import { STATIC_COLORS } from './utils/colors';

export const DEFAULT_THEME: DefaultTheme = {
  /**
   * STATIC_COLORS comes from the config-tailwind package via /utils/colors.
   * We should remove this in favour of using config-tailwind directly.
   */
  colors: {
    brand: STATIC_COLORS.BRAND,
    primary: STATIC_COLORS.GREEN,
    primaryDarker: STATIC_COLORS.GREEN_DARKER,
    black: STATIC_COLORS.BLACK,
    white: STATIC_COLORS.WHITE,
    sephia: STATIC_COLORS.SEPHIA,
    text: STATIC_COLORS.BLACK,
    link: STATIC_COLORS.BLACK,
    textLighter: STATIC_COLORS.WHITE,
    grayLighter: STATIC_COLORS.GRAY_LIGHTER,
    grayLightest: STATIC_COLORS.GRAY_LIGHTEST,
    gray: STATIC_COLORS.GRAY,
    grayDarker: STATIC_COLORS.GRAY_DARKER,
    background: STATIC_COLORS.SEPHIA,
    backgroundDarker: STATIC_COLORS.BLACK,
    componentBackground: STATIC_COLORS.GREEN_BACKGROUND,
    componentBackgroundDarker: STATIC_COLORS.GREEN_BACKGROUND_DARKER,
    success: STATIC_COLORS.SUCCESS,
    warning: STATIC_COLORS.WARNING,
    error: STATIC_COLORS.ERROR,
    buttonPrimary: STATIC_COLORS.GREEN,
    buttonPrimaryDarker: STATIC_COLORS.GREEN_DARKER,
    buttonSecondary: STATIC_COLORS.GREEN_BACKGROUND,
    buttonSecondaryDarker: STATIC_COLORS.GREEN_BACKGROUND_DARKER,
    buttonPrimaryHover: '#121f1a',
  },
  spacing: {
    small: '10px',
    medium: '15px',
    large: '20px',
  },
  font: {
    default: 'FilsonPro, Arial, sans-serif',
    prices: 'FilsonProPrice, Arial, sans-serif',
  },
  fontSize: {
    default: '1rem',
    xxl: '2.25rem', //l
    xl: '1.75rem',
    l: '1.25rem', //m
    m: '1rem', //s
    s: '0.875rem', //xs
    xs: '0.75rem', //xxs
    xxs: '0.625rem',
  },
  fontWeights: {
    default: '400',
    semiBold: '500',
    bold: '600',
    heavy: '700',
  },
};
